import { BusyService } from "../../../services/busy-service";
import { WebApiService } from "../../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

//import 'ag-grid-enterprise/main';
import { observable, computedFrom, autoinject, bindable } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { DialogService } from "aurelia-dialog";
import { PageMessageService } from "../../../services/page-message-service";
import { SecurityService } from "../../../services/security-service";
import { ActivityStreamItemBase } from "../../../data/typegen/dtos/activity-stream-item-base";


@autoinject()
export class ActivityStream {

    public tinyMceOptions: any;

    public fileInput: HTMLInputElement;
    public fileCount: number;
    public totalSize: number;
    public selectedFiles: any[] = [];

    public filter = {showAll: false};

    @bindable() public isExternalView: boolean = false; // show activity from related tasks
    @bindable() public target: "task" | "request";

    @bindable()
    // @observable()
    public taskId: any;
    // public taskIdChanged() {
    //     if (this.taskId) {
    //         this.getActivityStream(this.taskId);
    //     }
    // }

    @bindable()
    public activityStream: ActivityStreamItemBase[] = [];

    constructor(
        private busyService: BusyService,
        private securityService: SecurityService,
        private dialogService: DialogService,
        private pageMessageService: PageMessageService,
        private api: WebApiService) {

    }

    public attached(): void {
    }

    private async getActivityStream(taskId: string) {

        this.busyService.on();
        try {
            var result = await this.api.get("Task", "getActivityStream", { taskId: taskId });
            const activityStream = JSON.parse(result.response);
            this.activityStream = activityStream;
        } finally {
            this.busyService.off();
        }
    }

}